import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  Input,
  Optional,
} from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-ssn-input',
  templateUrl: './ssn-input.component.html',
  styleUrls: ['./ssn-input.component.css'],
})
export class SsnInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  @Input() showViewSSNButton: boolean = false;
  @Input() hasSSN: boolean = false;
  @Input() employeeId: number;
  hasMask: boolean;

  @ViewChild('ssnInput') input: ElementRef;
  private isEditing = false;

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();
    this.hasMask = this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes['readonly'] != null) {
      if (this.readonly) {
        this.stopEditing();
      }
    }
    this.hasMask = this.fgInfo && this.fgInfo.mask && this.fgInfo.mask.trim() !== '';
  }

  getCanEdit() {
    return this.isEditing || !this.formControl.value;
  }

  onFocus() {
    if (this.getCanEdit()) {
      this.startEditing();
      this.input.nativeElement.value = null;
    }
  }

  onFocusOut() {
    if (this.formControl.valid) {
      this.stopEditing();
    }
  }

  toggleEditSsn() {
    // field should be editable, empty, and type should be text
    this.isEditing = true;
    this.formControl.patchValue(null);
    this.input.nativeElement.type = 'text';
  }

  showEdit() {
    return this.getReadonly() && !this.disabled && !this.readonly;
  }

  getReadonly() {
    return !this.isEditing && this.formControl.value;
  }

  private startEditing() {
    this.isEditing = true;
    this.input.nativeElement.type = 'text';
  }

  private stopEditing() {
    if (this.input) {
      this.input.nativeElement.type = 'text';
      if (this.input.nativeElement.value) {
        this.input.nativeElement.value =
          '***-**-' +
          this.input.nativeElement.value.substring(
            this.input.nativeElement.value.length - 4,
            this.input.nativeElement.value.length,
          );
      }
    }
    this.isEditing = false;
  }
}
